"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZDMFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZDMFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.366 10.137c.425 0 .735-.138.931-.413.2-.275.301-.695.301-1.26 0-.373-.044-.677-.133-.91-.084-.238-.21-.413-.378-.525-.168-.112-.38-.168-.637-.168h-.497v3.276h.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H2Zm0 7.998v-.686l2.002-3.451H2.175V6h2.961v.686l-2.023 3.437H5.15v.875H2Zm3.952 0V6H7.5c.434 0 .81.093 1.127.28.318.182.563.455.735.819.178.364.266.817.266 1.358 0 .546-.09 1.008-.273 1.386a1.913 1.913 0 0 1-.763.861c-.326.196-.716.294-1.169.294h-1.47ZM10.114 6v4.998h.91V9.913c0-.163-.004-.34-.013-.532a12.899 12.899 0 0 0-.028-.595c-.01-.205-.022-.406-.036-.602a46.48 46.48 0 0 0-.041-.546 123.603 123.603 0 0 1-.056-.721h.042l.553 2.905h.986l.512-2.898h.042c0 .051-.005.138-.014.259l-.036.441c-.009.168-.02.35-.035.546a988.576 988.576 0 0 0-.056 1.183c-.004.187-.006.355-.006.504v1.141h.91V6h-1.303l-.504 2.835h-.027L11.486 6h-1.372Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZDMFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZDMFill;
exports["default"] = _default;